import { styled } from '@mui/system'
import { Grid } from '@mui/material'

export const LoginContainer = styled(Grid)({
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})
